if (!customElements.get('product-image-modal')) {
  customElements.define('product-image-modal', class extends HTMLElement {
    constructor() {
      super();
      this.images = [];
      this.currentIndex = 0;
      this.isTransitioning = false;
      
      // Create modal structure directly in document.body like the original
      const modal = document.createElement('div');
      modal.id = 'ProductImageModal';
      modal.className = 'product-image-modal';
      modal.innerHTML = `
        <div class="modal-content">
          <div class="touch-scroll-container">
            <div class="modal-image-container">
              <div class="modal-loader"></div>
              <img class="modal-image" alt="" />
            </div>
          </div>
          <div class="modal-control-bar">
            <button class="modal-btn close-btn" aria-label="Fermer">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
            <div class="modal-separator"></div>
            <button class="modal-btn prev-btn" aria-label="Précédente">
              <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"></polyline></svg>
            </button>
            <button class="modal-btn next-btn" aria-label="Suivante">
              <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </button>
            <div class="modal-separator"></div>
            <button class="modal-btn share-btn" aria-label="Partager">
              <svg viewBox="0 0 16 16"><path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.5 2.5 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5"/></svg>
            </button>
          </div>
        </div>
      `;
      document.body.appendChild(modal);
      
      // Cache DOM elements
      this.modal = modal;
      this.image = modal.querySelector('.modal-image');
      this.container = modal.querySelector('.touch-scroll-container');
      
      // Set up event listeners
      this.image.addEventListener('load', () => {
        this.modal.classList.remove('modal-loading');
        this.isTransitioning = false;
      });
      
      // Setup event listeners
      this.setupEventListeners();
      this.collectImages();
      this.observeGallery();
    }
    
    setupEventListeners() {
      // Button controls
      this.modal.querySelector('.close-btn').addEventListener('click', () => this.closeModal());
      this.modal.querySelector('.prev-btn').addEventListener('click', () => this.showPrevImage());
      this.modal.querySelector('.next-btn').addEventListener('click', () => this.showNextImage());
      this.modal.querySelector('.share-btn').addEventListener('click', () => this.shareProduct());
      
      // Touch swipe
      let touchStartX = 0;
      this.container.addEventListener('touchstart', e => touchStartX = e.changedTouches[0].screenX);
      this.container.addEventListener('touchend', e => {
        const diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) diff > 0 ? this.showNextImage() : this.showPrevImage();
      });
      
      // Click outside to close
      this.modal.addEventListener('click', e => {
        if (e.target === this.modal) this.closeModal();
      });
      
      // Keyboard navigation
      document.addEventListener('keydown', e => {
        if (!this.modal.classList.contains('active')) return;
        if (e.key === 'Escape') this.closeModal();
        if (e.key === 'ArrowLeft') this.showPrevImage();
        if (e.key === 'ArrowRight') this.showNextImage();
      });
      
      // Global click interception for gallery images
      document.addEventListener('click', e => {
        const mediaItem = e.target.closest('.product__media-item');
        if (!mediaItem || mediaItem.classList.contains('filtered-variant')) return;
        if (e.target.tagName === 'BUTTON' || e.target.closest('button')) return;
        
        const mediaId = mediaItem.dataset.mediaId;
        if (!mediaId) return;
        
        const index = this.images.findIndex(img => img.mediaId === mediaId);
        if (index === -1) return;
        
        e.preventDefault();
        e.stopPropagation();
        this.openModal(index);
      }, true);
      
      // Handle variant changes
      document.addEventListener('variant:changed', () => setTimeout(() => this.collectImages(), 100));
    }
    
    collectImages() {
      const gallery = document.querySelector('media-gallery');
      if (!gallery) return;
      
      this.images = [];
      gallery.querySelectorAll('.product__media-item:not(.filtered-variant)').forEach(item => {
        const image = item.querySelector('.product__media img');
        if (!image) return;
        
        this.images.push({
          original: image.src.replace(/_(small|medium|large|grande|original|1024x1024|2048x2048|master)\./, '_2048x2048.'),
          alt: image.alt || 'Product image',
          mediaId: item.dataset.mediaId
        });
        
        item.style.cursor = 'pointer';
      });
      
      if (this.modal.classList.contains('active') && this.currentIndex >= this.images.length) {
        this.images.length > 0 ? this.updateImage(0) : this.closeModal();
      }
    }
    
    observeGallery() {
      const gallery = document.querySelector('media-gallery');
      if (!gallery) return;
      
      new MutationObserver(mutations => {
        for (const mutation of mutations) {
          if ((mutation.type === 'attributes' && 
               mutation.attributeName === 'class' && 
               (mutation.target.classList.contains('filtered-variant') || 
                (mutation.oldValue && mutation.oldValue.includes('filtered-variant')))) || 
              mutation.type === 'childList') {
            this.collectImages();
            break;
          }
        }
      }).observe(gallery, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ['class']
      });
    }
    
    openModal(index) {
      if (!this.images.length || this.isTransitioning) return;
      this.isTransitioning = true;
      
      const img = new Image();
      img.onload = () => {
        this.currentIndex = index;
        this.image.src = img.src;
        this.image.alt = this.images[index].alt || '';
        document.body.style.overflow = 'hidden';
        this.modal.classList.add('modal-loading', 'active');
      };
      img.src = this.images[index].original;
    }
    
    closeModal() {
      if (this.isTransitioning && !this.modal.classList.contains('active')) return;
      this.modal.classList.remove('active');
      document.body.style.overflow = '';
      setTimeout(() => this.isTransitioning = false, 300);
    }
    
    showPrevImage() {
      if (this.images.length <= 1 || this.isTransitioning) return;
      this.updateImage((this.currentIndex - 1 + this.images.length) % this.images.length);
    }
    
    showNextImage() {
      if (this.images.length <= 1 || this.isTransitioning) return;
      this.updateImage((this.currentIndex + 1) % this.images.length);
    }
    
    updateImage(index) {
      if (this.isTransitioning || index === this.currentIndex) return;
      this.isTransitioning = true;
      this.modal.classList.add('modal-loading');
      
      const img = new Image();
      img.onload = () => {
        this.image.src = img.src;
        this.image.alt = this.images[index].alt || '';
        this.currentIndex = index;
      };
      img.src = this.images[index].original;
    }
    
    shareProduct() {
      const url = window.location.href;
      const title = document.title;
      
      if (navigator.share) {
        navigator.share({title, url}).catch(() => this.fallbackShare());
      } else {
        this.fallbackShare();
      }
    }
    
    fallbackShare() {
      const tempInput = document.createElement('input');
      tempInput.value = window.location.href;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      
      const toast = document.createElement('div');
      toast.className = 'modal-share-toast';
      toast.textContent = 'URL copiée!';
      document.body.appendChild(toast);
      setTimeout(() => document.body.removeChild(toast), 2000);
    }
  });
}

// Create the custom element when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('media-gallery')) {
    document.body.appendChild(document.createElement('product-image-modal'));
  }
});